import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { initAttribution } from "./utils/trafficAttribution";

// Before the app renders — and so before the router, a redirect or a language switch can move the
// visitor off the landing URL. That is the only moment the UTM tags and the original document.referrer
// are guaranteed to still be there.
initAttribution();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
